import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-corner-mark-color",
  "use": "icon-corner-mark-color-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-corner-mark-color\">\n<path d=\"M26 0H0L32 32V6C32 2.68629 29.3137 0 26 0Z\" fill=\"#1890FF\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.7695 12.6603L18.2967 10.1875C18.1952 10.086 18.0741 10.0548 17.9333 10.0938C17.7926 10.1328 17.7047 10.2207 17.6697 10.3574C17.6347 10.4942 17.668 10.6172 17.7695 10.7264L20.7695 13.7264L26.7695 7.72641C26.8397 7.64816 26.873 7.55829 26.8692 7.45679C26.8655 7.35529 26.8263 7.26741 26.7518 7.19316C26.6773 7.11891 26.5913 7.08179 26.4938 7.08179C26.3963 7.08179 26.3085 7.11691 26.2302 7.18716L20.7695 12.6603Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/corner-mark-color.svg
// module id = tFrl
// module chunks = 258